<template>
    <div>
        <template v-if="declarationsLoading">
            <loading-spinner/>
        </template>

        <template v-else>
            <x-container fluid app-width>
                <x-layout align-items my-5>
                    <x-flex>
                        <h1>Reports</h1>
                    </x-flex>

                    <x-flex text-xs-right d-none>  <!-- temporarily hidden using d-none -->
                        <x-btn
                            v-on:click="onShowChart()"
                            class="ml-0"
                            color="primary"
                            large
                            :disabled="disableShowChartBtn"
                        >
                            Show Chart
                        </x-btn>
                    </x-flex>
                </x-layout>

                <x-layout>
                    <x-flex>
                        <x-container fluid class="summary-container">
                            <x-layout class="filter-panel">
                                <x-flex xs12 class="filter-panel-options" pt-0>
                                    <x-layout align-center>
                                        <x-flex xs1 mt-1 class="label-view text-xs-center">
                                            View
                                        </x-flex>

                                        <x-flex xs3>
                                            <x-select
                                                :items="this.tableViews"
                                                v-model="tableView"
                                                @input="this.switch"
                                                :disabled="offersLoading"
                                                :loading="offersLoading"
                                                append-icon="keyboard_arrow_down"
                                                class="input-no-margin"
                                                outline
                                                hide-details
                                            />
                                        </x-flex>

                                        <x-flex xs3>
                                            <x-select
                                                :items="this.filteredTableLayouts"
                                                placeholder="Saved views"
                                                v-model="layout"
                                                item-text="name"
                                                @input="loadTableLayout(layout)"
                                                return-object
                                                append-icon="keyboard_arrow_down"
                                                class="input-no-margin"
                                                outline
                                                hide-details
                                            />
                                        </x-flex>
                                        <x-flex xs3 mt-1>
                                            <x-layout>
                                                <x-flex class="grow-0 text-xs-center">
                                                    <x-btn
                                                        v-on:click="saveTableLayout()"
                                                        class="filter-btn"
                                                        small
                                                        color="tertiary"
                                                    >
                                                        Save
                                                    </x-btn>
                                                </x-flex>

                                                <x-flex class="grow-0 text-xs-center">
                                                    <x-menu offset-y>
                                                        <template v-slot:activator="{ on }">
                                                            <x-btn
                                                                v-on="on"
                                                                class="filter-btn"
                                                                color="tertiary"
                                                                small
                                                            >
                                                                Export
                                                            </x-btn>
                                                        </template>
                                                        <x-list>
                                                            <x-list-tile @click="exportDataAsCsv">
                                                                <x-list-tile-title>CSV</x-list-tile-title>
                                                            </x-list-tile>
                                                            <x-list-tile @click="exportDataAsExcel">
                                                                <x-list-tile-title>Excel</x-list-tile-title>
                                                            </x-list-tile>
                                                        </x-list>
                                                    </x-menu>
                                                </x-flex>

                                                <x-flex class="grow-0 text-xs-center">
                                                    <x-btn
                                                        v-on:click="resetTableLayout()"
                                                        :disabled="disableResetBtn"
                                                        class="filter-btn"
                                                        color="tertiary"
                                                        small
                                                    >
                                                        Reset
                                                    </x-btn>
                                                </x-flex>
                                            </x-layout>
                                        </x-flex>
                                        <x-flex xs3 mt-1 class="text-xs-right">
                                            <div class="grid-totals">Showing <span v-html="paginationSummary"/></div>
                                        </x-flex>
                                    </x-layout>
                                </x-flex>
                            </x-layout>
                            <x-layout mt-4>
                                <ag-grid-vue
                                    style="width: 100%; height: 500px;"
                                    class="ag-theme-balham-dark"
                                    id="reportingGrid"
                                    :gridOptions="gridOptions"
                                    @grid-ready="onGridReady"
                                    :columnDefs="declarationColumnDefinition"
                                    :rowData="this.lines"
                                    :defaultColDef="defaultColDef"
                                    :animateRows="true"
                                    :enableRangeSelection="true"
                                    groupDefaultExpanded="-1"
                                    rowGroupPanelShow="always"
                                    :sideBar="sideBar"
                                    :getContextMenuItems="getContextMenuItems"
                                    :pagination="true"
                                    :paginationAutoPageSize="true"
                                    @pagination-changed="onPaginationChanged"
                                />
                            </x-layout>
                        </x-container>
                    </x-flex>
                </x-layout>
            </x-container>
        </template>
        <modal
            ref="saveDialog"
            title="Save layout"
            confirmation
        >
            <field-group title="Layout name:">
                <x-text-field v-model="newLayoutName" placeholder="Layout name"/>
            </field-group>
        </modal>

    </div>
</template>

<script>
    import {AgGridVue} from "ag-grid-vue";
    import {LicenseManager} from "ag-grid-enterprise";
    import currency from "../filters/Currency";
    import riskStatus from "../filters/RiskStatus";
    import Modal from '~/components/Shared/UIComponents/Modal';

    LicenseManager.setLicenseKey('Using_this_{AG_Grid}_Enterprise_key_{AG-075534}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Howden_Insurance_Brokers_Ltd}_is_granted_a_{Multiple_Applications}_Developer_License_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{5}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{21_March_2026}____[v3]_[01]_MTc3NDA1MTIwMDAwMA==e50984d2fba68803e5db54adb3029eb7');

    export default {
        name: "Reports",
        components: {
            AgGridVue,
            Modal,
        },
        data() {
            return {
                currentStep: 1,
                declarationsLoading: true,
                offersLoading: true,
                manualSubmissionsLoading: true,
                profile: null,
                lines: [],
                offers: [],
                manualSubmissions: [],
                gridOptions: null,
                gridApi: null,
                columnApi: null,
                offerColumnDefs: null,
                rowData: null,
                defaultColDef: null,
                sideBar: null,
                tableLayouts: [],
                declarationTableLayouts: [],
                offerTableLayouts: [],
                layout: {
                    name: 'Saved views'
                },
                newLayoutName: null,
                tableViews: ['Declarations', 'Offers'],
                tableView: 'Declarations',
                disableResetBtn: true,
                disableShowChartBtn: false,
                createdChartRef: null,
                paginationSummary: null,
            }
        },
        computed: {
            filteredTableLayouts() {
                return [
                    {
                        name: 'Default'
                    },
                    ...this.tableLayouts
                ];
            },
            isInsurer() {
                return this.$route.path === '/insurer/reports';
            },
            isBroker() {
                return this.$route.path === '/agent/reports';
            },
            fileName() {
                return this.tableView + ' - ' + this.layout.name;
            },
            rowStartIndex() {
                if (this.gridApi) {
                    const totalRowsPerPage = this.gridApi.paginationGetPageSize();

                    return this.gridApi.paginationGetCurrentPage() * totalRowsPerPage;
                }

                return 0;
            },
            rowEndIndex() {
                if (this.gridApi) {
                    const totalRowsPerPage = this.gridApi.paginationGetPageSize();

                    return this.rowStartIndex + (totalRowsPerPage - 1);
                }

                return 12;
            },
            declarationColumnDefinition() {
                if (this.isInsurer) {
                    return this.insurerDeclarationColumnDefs.concat(this.commonDeclarationColumnDefinition);
                }
                return this.brokerDeclarationColumnDefs.concat(this.commonDeclarationColumnDefinition);
            },
            commonDeclarationColumnDefinition() {
                return [
                    {
                        headerName: "Currency",
                        field: "currency_code"
                    },
                    {
                        headerName: "Placing Broker",
                        field: "placing_broker_name"
                    },
                    {
                        headerName: "Producing Broker",
                        field: "producing_broker_name"
                    },
                    {
                        headerName: "Date Submitted",
                        field: "submission_created_at",
                        filter: "agDateColumnFilter",
                        valueFormatter: params => this.$moment(params.value).format('DD/MM/YYYY'),
                        useValueFormatterForExport: false,
                        filterParams: {
                            comparator: (filterLocalDateAtMidnight, cellValue) => {
                                return this.compareDates(filterLocalDateAtMidnight, cellValue);
                            },
                            browserDatePicker: true
                        }
                    },
                    {
                        headerName: "Date Offered",
                        field: "offer_created_at",
                        filter: "agDateColumnFilter",
                        valueFormatter: params => this.$moment(params.value).format('DD/MM/YYYY'),
                        useValueFormatterForExport: false,
                        filterParams: {
                            comparator: (filterLocalDateAtMidnight, cellValue) => {
                                return this.compareDates(filterLocalDateAtMidnight, cellValue);
                            },
                            browserDatePicker: true
                        }
                    },
                    {
                        headerName: "Date Bound",
                        field: "bound_date",
                        filter: "agDateColumnFilter",
                        valueFormatter: params => this.$moment(params.value).format('DD/MM/YYYY'),
                        useValueFormatterForExport: false,
                        filterParams: {
                            comparator: (filterLocalDateAtMidnight, cellValue) => {
                                return this.compareDates(filterLocalDateAtMidnight, cellValue);
                            },
                            browserDatePicker: true
                        }
                    },
                    {
                        headerName: "Date Last Updated",
                        field: "last_update_at",
                        filter: "agDateColumnFilter",
                        valueFormatter: params => this.$moment(params.value).format('DD/MM/YYYY'),
                        useValueFormatterForExport: false,
                        filterParams: {
                            comparator: (filterLocalDateAtMidnight, cellValue) => {
                                return this.compareDates(filterLocalDateAtMidnight, cellValue);
                            },
                            browserDatePicker: true
                        }
                    },
                    {
                        headerName: "Inception date",
                        field: "inception_date",
                        filter: "agDateColumnFilter",
                        valueFormatter: params => this.$moment(params.value).format('DD/MM/YYYY'),
                        useValueFormatterForExport: false,
                        filterParams: {
                            comparator: (filterLocalDateAtMidnight, cellValue) => {
                                return this.compareDates(filterLocalDateAtMidnight, cellValue);
                            },
                            browserDatePicker: true
                        }
                    },
                    {
                        headerName: "Expiry date",
                        field: "expiry_date",
                        filter: "agDateColumnFilter",
                        valueFormatter: params => this.$moment(params.value).format('DD/MM/YYYY'),
                        useValueFormatterForExport: false,
                        filterParams: {
                            comparator: (filterLocalDateAtMidnight, cellValue) => {
                                return this.compareDates(filterLocalDateAtMidnight, cellValue);
                            },
                            browserDatePicker: true
                        }
                    },
                    {
                        headerName: "Method of placement",
                        field: "method_of_placement"
                    },
                    {
                        headerName: "Lead/Follow",
                        field: "lead_or_follow"
                    },
                    {
                        headerName: "Date Off Risk",
                        field: "off_risk_at",
                        filter: "agDateColumnFilter",
                        valueFormatter: params => this.$moment(params.value).format('DD/MM/YYYY'),
                        useValueFormatterForExport: false,
                        filterParams: {
                            comparator: (filterLocalDateAtMidnight, cellValue) => {
                                return this.compareDates(filterLocalDateAtMidnight, cellValue);
                            },
                            browserDatePicker: true
                        }
                    },
                    {
                        headerName: "Dec UMR",
                        field: "declaration_umr"
                    },
                    {
                        headerName: "Facility UMR",
                        field: "facility_umr"
                    },
                    {
                        headerName: "UW Reference",
                        field: "uw_reference"
                    },
                    {
                        headerName: "UW Risk Code",
                        valueGetter: this.riskCodes,
                    },
                    {
                        headerName: "Line Size Offered %",
                        field: "line_size_percent",
                        valueFormatter: this.percentageFormatter,
                        useValueFormatterForExport: false,
                        filterParams: {
                            valueFormatter: this.percentageFormatter
                        },
                        keyCreator: params => {
                            return params.value === null || typeof params.value === 'undefined' ? '' : this.numberFormatter(params.value);
                        },
                    },
                    {
                        headerName: "Signed Line Size %",
                        field: "signed_line_percent",
                        valueFormatter: this.percentageFormatter,
                        useValueFormatterForExport: false,
                        filterParams: {
                            valueFormatter: this.percentageFormatter
                        },
                        keyCreator: params => {
                            return params.value === null || typeof params.value === 'undefined' ? '' : this.numberFormatter(params.value);
                        },
                    },
                    {
                        headerName: "Line Size Offered Amount",
                        field: "line_size_amount",
                        filter: "agNumberColumnFilter",
                        valueFormatter: this.currencyFormatter,
                        useValueFormatterForExport: false,
                        keyCreator: params => {
                            return params.value === null || typeof params.value === 'undefined' ? '' : this.numberFormatter(params.value);
                        },
                    },
                    {
                        headerName: "Line Size Signed",
                        field: "line_size_signed_amount",
                        filter: "agNumberColumnFilter",
                        valueFormatter: this.currencyFormatter,
                        useValueFormatterForExport: false,
                        keyCreator: params => {
                            return params.value === null || typeof params.value === 'undefined' ? '' : this.numberFormatter(params.value);
                        },
                    },
                    {
                        headerName: "UW Rate Offered",
                        field: "uw_rate_offered",
                        valueFormatter: this.bpsFormatter,
                        useValueFormatterForExport: false,
                    },
                    {
                        headerName: "UW Rate Signed",
                        field: "uw_rate_signed",
                        valueFormatter: this.bpsFormatter,
                        useValueFormatterForExport: false,
                    },
                    {
                        headerName: "UW % of Margin Offered",
                        field: "uw_percentage_of_margin_offered",
                        valueFormatter: this.percentageFormatter,
                        useValueFormatterForExport: false,
                        filterParams: {
                            valueFormatter: this.percentageFormatter
                        },
                        keyCreator: params => {
                            return params.value === null || typeof params.value === 'undefined' ? '' : this.numberFormatter(params.value);
                        },
                    },
                    {
                        headerName: "UW % of Margin Signed",
                        field: "uw_percentage_of_margin_signed",
                        valueFormatter: this.percentageFormatter,
                        useValueFormatterForExport: false,
                        filterParams: {
                            valueFormatter: this.percentageFormatter
                        },
                        keyCreator: params => {
                            return params.value === null || typeof params.value === 'undefined' ? '' : this.numberFormatter(params.value);
                        },
                    },
                    {
                        headerName: "UW Fee",
                        field: "flat_fee",
                        filter: "agNumberColumnFilter",
                        valueFormatter: this.currencyFormatter,
                        useValueFormatterForExport: false,
                        keyCreator: params => {
                            return params.value === null || typeof params.value === 'undefined' ? '' : this.numberFormatter(params.value);
                        },
                    },
                    {
                        headerName: "Final Premium",
                        field: "final_premium",
                        filter: "agNumberColumnFilter",
                        valueFormatter: this.currencyFormatter,
                        useValueFormatterForExport: false,
                        keyCreator: params => {
                            return params.value === null || typeof params.value === 'undefined' ? '' : this.numberFormatter(params.value);
                        },
                    },
                ];
            },
            brokerDeclarationColumnDefs() {
                return [
                    {
                        headerName: "Risk ID",
                        field: "risk_id"
                    },
                    {
                        headerName: "Quote Type",
                        field: "quote_type_name"
                    },
                    {
                        headerName: "Dec Status",
                        field: "declaration_status",
                        valueFormatter: this.statusFormatter,
                        useValueFormatterForExport: false,
                    },
                    {
                        headerName: "Offer ID",
                        field: "offer_id"
                    },
                    {
                        headerName: "Offer Status",
                        field: "offer_status"
                    },
                    {
                        headerName: "Client",
                        field: "client_company_name"
                    },
                    {
                        headerName: "Obligor",
                        field: "obligor_name"
                    },
                    {
                        headerName: "Obligor Country",
                        field: "obligor_country_name"
                    },
                    {
                        headerName: "Guarantor",
                        field: "guarantor_name"
                    },
                    {
                        headerName: "Guarantor Country",
                        field: "guarantor_country_name"
                    },
                    {
                        headerName: "UW Name",
                        field: "uw_name"
                    },
                    {
                        headerName: "UW Security",
                        field: "security_name"
                    },
                    {
                        headerName: "Brokerage",
                        field: "brokerage",
                        valueFormatter: this.percentageFormatter,
                        useValueFormatterForExport: false,
                        filterParams: {
                            valueFormatter: this.percentageFormatter
                        },
                        keyCreator: params => {
                            return params.value === null || typeof params.value === 'undefined' ? '' : this.numberFormatter(params.value);
                        }
                    },
                    {
                        headerName: "Product",
                        field: "product_name"
                    },
                    {
                        headerName: "Category",
                        field: "category_name"
                    },
                    {
                        headerName: "Sector",
                        field: "sector_name"
                    },
                    {
                        headerName: "Sub Sector",
                        field: "sub_sector_name"
                    },
                    {
                        headerName: "Sector Colour",
                        field: "sector_colour"
                    },
                ];
            },
            insurerDeclarationColumnDefs() {
                return [
                    {
                        headerName: "Risk ID",
                        field: "risk_id"
                    },
                    {
                        headerName: "Quote Type",
                        field: "quote_type_name"
                    },
                    {
                        headerName: "Dec Status",
                        field: "declaration_status",
                        valueFormatter: this.statusFormatter,
                        useValueFormatterForExport: false,
                    },
                    {
                        headerName: "Client",
                        field: "client_company_name"
                    },
                    {
                        headerName: "Obligor",
                        field: "obligor_name"
                    },
                    {
                        headerName: "Obligor Country",
                        field: "obligor_country_name"
                    },
                    {
                        headerName: "Guarantor",
                        field: "guarantor_name"
                    },
                    {
                        headerName: "Guarantor Country",
                        field: "guarantor_country_name"
                    },
                    {
                        headerName: "UW Security",
                        field: "security_name"
                    },
                    {
                        headerName: "Product",
                        field: "product_name"
                    },
                    {
                        headerName: "Category",
                        field: "category_name"
                    },
                    {
                        headerName: "Sector",
                        field: "sector_name"
                    },
                    {
                        headerName: "Sub Sector",
                        field: "sub_sector_name"
                    },
                ];
            },
            canUserViewManualSubmissions() {
                return this.$root.userIsPlacingBrokerUser();
            }
        },
        watch: {
            '$root.user'() {
                this.profile = this.$root.user;
            }
        },
        async created() {
            await this.fetchData();
            if (this.canUserViewManualSubmissions) {
                this.tableViews.push('Manual Submissions');
            }
        },
        beforeMount() {
            this.gridOptions = {
                enableRangeSelection: true,
                rowHeight: 40
            };

            this.offerColumnDefs = [
                {
                    headerName: "Risk ID",
                    field: "risk_id"
                },
                {
                    headerName: "Offer Type",
                    valueGetter: (params) => { return this.getOfferType(params.data.type) },
                    filterValueGetter: (params) => { return this.getOfferType(params.data.type) },
                },
                {
                    headerName: "Status",
                    valueGetter: this.statusFormatter,
                    filterValueGetter: this.statusFormatter,
                },
                {
                    headerName: "Client",
                    field: "client_company_name"
                },
                {
                    headerName: "Obligor",
                    field: "obligor_name"
                },
                {
                    headerName: "Obligor Country",
                    field: "obligor_country_name"
                },
                {
                    headerName: "Tenor",
                    field: "total_risk_period",
                    valueFormatter: this.yearsAndDaysFormatter,
                    useValueFormatterForExport: false,
                }
            ];
            if (this.isInsurer) {
                this.offerColumnDefs.push({
                    headerName: "Received at",
                    field: "created_at",
                    filter: "agDateColumnFilter",
                    valueFormatter: params => this.$moment(params.value).format('DD/MM/YYYY'),
                    useValueFormatterForExport: false,
                    filterParams: {
                        comparator: (filterLocalDateAtMidnight, cellValue) => {
                            return this.compareDates(filterLocalDateAtMidnight, cellValue);
                        },
                        browserDatePicker: true
                    }
                });
            }

            this.offerColumnDefs.push(
                {
                    headerName: "Submitted at",
                    field: "submitted_at",
                    filter: "agDateColumnFilter",
                    valueFormatter: params => this.$moment(params.value).format('DD/MM/YYYY'),
                    useValueFormatterForExport: false,
                    filterParams: {
                        comparator: (filterLocalDateAtMidnight, cellValue) => {
                            return this.compareDates(filterLocalDateAtMidnight, cellValue);
                        },
                        browserDatePicker: true
                    }
                },
                {
                    headerName: "Offered Line Percent",
                    field: "line_size_percent",
                    filter: "agNumberColumnFilter",
                    valueFormatter: this.percentageFormatter,
                    useValueFormatterForExport: false,
                    filterParams: {
                        valueFormatter: this.percentageFormatter
                    },
                    keyCreator: params => {
                        return params.value === null || typeof params.value === 'undefined' ? '' : this.numberFormatter(params.value);
                    },

                },
                {
                    headerName: "Offered Line Amount",
                    field: "line_size_amount",
                    filter: "agNumberColumnFilter",
                    valueFormatter: this.currencyFormatter,
                    useValueFormatterForExport: false,
                    keyCreator: params => {
                        return params.value === null || typeof params.value === 'undefined' ? '' : this.numberFormatter(params.value);
                    },
                },
                {
                    headerName: "Offered Price",
                    field: "price",
                    filter: "agNumberColumnFilter",
                    valueFormatter: this.bpsFormatter,
                    useValueFormatterForExport: false,
                },
                {
                    headerName: "Written Line Percent",
                    field: "signed_line_percent",
                    filter: "agNumberColumnFilter",
                    valueFormatter: this.percentageFormatter,
                    useValueFormatterForExport: false,
                    filterParams: {
                        valueFormatter: this.percentageFormatter
                    },
                    keyCreator: params => {
                        return params.value === null || typeof params.value === 'undefined' ? '' : this.numberFormatter(params.value);
                    },
                },
                {
                    headerName: "Written Line Amount",
                    field: "signed_line_amount",
                    filter: "agNumberColumnFilter",
                    valueFormatter: this.currencyFormatter,
                    useValueFormatterForExport: false,
                    keyCreator: params => {
                        return params.value === null || typeof params.value === 'undefined' ? '' : this.numberFormatter(params.value);
                    },
                },
                {
                    headerName: "Written Price",
                    field: "line_price",
                    filter: "agNumberColumnFilter",
                    valueFormatter: this.bpsFormatter,
                    useValueFormatterForExport: false,
                },
                {
                    headerName: "Flat Fee",
                    field: "flat_fee",
                    filter: "agNumberColumnFilter",
                    valueFormatter: this.currencyFormatter,
                    useValueFormatterForExport: false,
                    keyCreator: params => {
                        return params.value === null || typeof params.value === 'undefined' ? '' : this.numberFormatter(params.value);
                    },
                },
                {
                    headerName: "Percentage of margin",
                    field: "percentage_of_margin",
                    filter: "agNumberColumnFilter",
                    valueFormatter: this.percentageFormatter,
                    useValueFormatterForExport: false,
                    filterParams: {
                        valueFormatter: this.percentageFormatter
                    },
                    keyCreator: params => {
                        return params.value === null || typeof params.value === 'undefined' ? '' : this.numberFormatter(params.value);
                    },
                },
                {
                    headerName: "Minimum price",
                    field: "minimum_price",
                    filter: "agNumberColumnFilter",
                    valueFormatter: this.bpsFormatter,
                    useValueFormatterForExport: false,
                },
                {
                    headerName: "Waiting Period",
                    field: "waiting_period",
                    filter: "agNumberColumnFilter",
                    valueFormatter: this.daysFormatter,
                    useValueFormatterForExport: false,
                },
                {
                    headerName: "Insurer",
                    field: "insurer_name"
                },
                {
                    headerName: "Security",
                    field: "line_security_name"
                },
                {
                    headerName: "Currency",
                    field: "currency_name"
                },
                {
                    headerName: "Decline Reason",
                    field: "decline_reason"
                },
                {
                    headerName: "Risk Code",
                    field: "risk_code",
                    filter: "agTextColumnFilter",
                },
                {
                    headerName: "Underwriter Reference",
                    field: "underwriter_reference",
                    filter: "agTextColumnFilter"
                },
                {
                    headerName: "Client",
                    field: "client_company_name"
                },
                {
                    headerName: "Obligor",
                    field: "obligor_name"
                },
                {
                    headerName: "Country",
                    field: "obligor_country_name"
                },
                {
                    headerName: "Tenor",
                    field: "total_risk_period",
                    valueFormatter: this.yearsAndDaysFormatter,
                    useValueFormatterForExport: false,
                }
            );
            this.defaultColDef = {
                sortable: true,
                filter: true,
                resizable: true,
                pivot: true,
                cellRenderer: 'agGroupCellRenderer',
                enableRowGroup: true
            };
            this.sideBar = {
                toolPanels: ['filters', 'columns']
            };
        },
        mounted() {
            this.gridApi = this.gridOptions.api;
            if (localStorage.declarationTableLayouts) {
                this.declarationTableLayouts = JSON.parse(localStorage.getItem('declarationTableLayouts'));
                this.tableLayouts = this.declarationTableLayouts;
            }
            if (localStorage.offerTableLayouts) {
                this.offerTableLayouts = JSON.parse(localStorage.getItem('offerTableLayouts'));
            }
        },
        methods: {
            async fetchData() {
                this.profile = this.$root.user;
                const endpoint = this.isInsurer ? 'insurer' : 'broker';

                this.lines = (await axios.get(this.$root.api(`${endpoint}/reporting/declaration`))).data.data;
                this.declarationsLoading = false;

                this.offers = (await axios.get(this.$root.api(`${endpoint}/reporting/offers`))).data.data;
                this.offersLoading = false;

                if (this.canUserViewManualSubmissions) {
                    this.manualSubmissions = (await axios.get(this.$root.api(`${endpoint}/reporting/manual-submissions`))).data.data;
                }
                this.manualSubmissionsLoading = false;
            },
            onGridReady(params) {
                params.api.sizeColumnsToFit();
                this.gridApi = params.api;

                this.autoSizeAll(false);
            },
            onPaginationChanged() {
                if (this.gridApi) {
                    this.recalculatePaginationSummary();
                    this.closeChart();
                }
            },
            isZeroPagesToDisplay() {
                const totalPages = this.gridApi.paginationGetTotalPages();
                return totalPages === 0;
            },
            // https://github.com/ag-grid/ag-grid/blob/latest/packages/ag-grid-community/src/pagination/paginationComp.ts#L248
            recalculatePaginationSummary() {
                const rowCount = this.gridApi.paginationGetRowCount();

                // When `pivotMode=true` and no grouping or value columns exist, a single 'hidden' group row (root node) is in
                // the grid and the pagination totals will correctly display total = 1. However this is confusing to users as
                // they can't see it. To address this UX issue we simply set the totals to zero in the pagination panel.
                if (rowCount === 1) {
                    const firstRow = this.gridApi.getDisplayedRowAtIndex(0);

                    // a group node with no group or agg data will not be visible to users
                    const hiddenGroupRow = firstRow && firstRow.group && !(firstRow.groupData || firstRow.aggData);
                    if (hiddenGroupRow) {
                        this.paginationSummary = '0 to 0 of 0';
                        return;
                    }
                }

                const currentPage = this.gridApi.paginationGetCurrentPage();
                const pageSize = this.gridApi.paginationGetPageSize();

                let startRow;
                let endRow;

                if (this.isZeroPagesToDisplay()) {
                    startRow = endRow = 0;
                } else {
                    startRow = pageSize * currentPage + 1;
                    endRow = startRow + pageSize - 1;
                    if (endRow > rowCount) {
                        endRow = rowCount;
                    }
                }

                this.paginationSummary =  startRow + ' to ' + endRow + ' of ' + rowCount;
            },
            autoSizeAll(skipHeader) {
                let allColumnIds = [];
                this.gridApi.getColumns().forEach(function (column) {
                    allColumnIds.push(column.colId);
                });
                this.gridApi.autoSizeColumns(allColumnIds, skipHeader);
            },
            exportDataAsCsv() {
                this.gridApi.exportDataAsCsv({ fileName: this.fileName });
            },
            exportDataAsExcel() {
                this.gridApi.exportDataAsExcel(
                    {
                        sheetName: this.fileName,
                        fileName: this.fileName
                    }
                );
            },
            compareDates(filterLocalDateAtMidnight, cellValue) {
                let dateAsString = this.$moment(cellValue).format('DD/MM/YYYY');
                if (dateAsString === null || typeof dateAsString === "undefined") { return -1; }
                let dateParts = dateAsString.split("/");
                let cellDate = new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]));
                if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                    return 0;
                }
                if (cellDate < filterLocalDateAtMidnight) {
                    return -1;
                }
                return 1;
            },
            loadTableLayout(layout) {
                if (layout.name === 'Default' || !layout.name) {
                    this.disableResetBtn = true;
                    this.gridApi.resetColumnState()
                    this.gridApi.setFilterModel(null);
                } else {
                    this.disableResetBtn = false;
                    this.gridApi.applyColumnState({ state: layout.layout });
                    this.gridApi.setFilterModel(layout.filters);
                }
            },
            async saveTableLayout() {
                if (await this.$refs.saveDialog.open() === false) {
                    return;
                }

                let tableLayouts;
                let localStorageKey;

                if (this.tableView === 'Declarations') {
                    tableLayouts = this.declarationTableLayouts;
                    localStorageKey = 'declarationTableLayouts';
                }
                if (this.tableView === 'Offers') {
                    tableLayouts = this.offerTableLayouts;
                    localStorageKey = 'offerTableLayouts';
                }

                this.tableLayouts.push({
                    name: this.newLayoutName,
                    layout: this.gridApi.getColumnState(),
                    filters: this.gridApi.getFilterModel()
                });

                localStorage.setItem(localStorageKey, JSON.stringify(this.tableLayouts));

                this.layout = {
                    name: this.newLayoutName,
                    layout: this.gridApi.getColumnState(),
                    filters: this.gridApi.getFilterModel()
                };
                this.newLayoutName = null;

                this.disableResetBtn = false;
            },
            currencyFormatter(params) {
                if (params.value === null || params.value === undefined || params.value === '') {
                    return '';
                }

                if (params.data) {
                    params.value = this.numberFormatter(params.value);

                    if (params.data.currency_code) {
                        return currency(params.value, params.data.currency_code);
                    }
                    if (params.data.declaration) {
                        return currency(params.value, params.data.declaration.currency.code);
                    }
                    if (params.data.submission) {
                        return currency(params.value, params.data.submission.currency.code);
                    }
                }

                return params.value;
            },
            percentageFormatter(params) {
                if (params.value === null || params.value === undefined || params.value === '') {
                    return '';
                }

                return this.numberFormatter(params.value) + "%";
            },
            bpsFormatter(params) {
                return params.value ? this.numberFormatter(params.value) + " bps" : '';
            },
            daysFormatter(params) {
                return params.value + " days";
            },
            yearsAndDaysFormatter(params) {
                return this.$options.filters.yearsAndDays(params.value);
            },
            numberFormatter(value, decimal = '') {
                if (value === null || value === undefined || value === '') {
                    return '';
                }

                return (typeof value === 'number') ? value.toFixed(decimal ? decimal : 2) : Number.parseFloat(value).toFixed(decimal ? decimal : 2);
            },
            statusFormatter(params) {
                if (params.data) {
                    const status = params.data.status ? params.data.status : params.data.declaration_status

                    return riskStatus(status);
                }

                return riskStatus(params.value);
            },
            switch() {
                if (this.tableView === 'Manual Submissions') {
                    this.disableShowChartBtn = true;
                    this.gridApi.setGridOption('columnDefs', [
                    {
                        headerName: "MST ID",
                        field: "manual_submission_id"
                    },
                    {
                        headerName: "MST Status",
                        field: "manual_submission_status"
                    },
                    {
                        headerName: "MST Offer ID",
                        field: "mst_offer_id"
                    },
                    {
                        headerName: "MST Offer Status",
                        field: "manual_submission_offer_status"
                    },
                    {
                        headerName: "Client",
                        field: "client_company_name"
                    },
                    {
                        headerName: "Obligor",
                        field: "obligor_name"
                    },
                    {
                        headerName: "Obligor Country",
                        field: "obligor_country_name"
                    },
                    {
                        headerName: "Guarantor",
                        field: "guarantor_name"
                    },
                    {
                        headerName: "Guarantor Country",
                        field: "guarantor_country_name"
                    },
                    {
                        headerName: "UW Name",
                        field: "uw_name"
                    },
                    {
                        headerName: "UW Security",
                        field: "security_name"
                    },
                    {
                        headerName: "UW Security Rating",
                        field: "security_rating"
                    },
                    {
                        headerName: "Max Line Size",
                        field: "security_max_line_size"
                    },
                    {
                        headerName: "Max Line Size Currency",
                        field: "security_max_line_currency"
                    },
                    {
                        headerName: "Max Tenor",
                        field: "security_max_tenor"
                    },
                    {
                        headerName: "Brokerage",
                        field: "brokerage",
                        valueFormatter: this.percentageFormatter,
                        useValueFormatterForExport: false,
                        filterParams: {
                            valueFormatter: this.percentageFormatter
                        },
                        keyCreator: params => {
                            return params.value === null || typeof params.value === 'undefined' ? '' : this.numberFormatter(params.value);
                        },
                    },
                    {
                        headerName: "Product",
                        field: "product_name"
                    },
                    {
                        headerName: "Loan radar ID",
                        field: "manual_submission_loan_radar_id"
                    },
                    {
                        headerName: "Category",
                        field: "category_name"
                    },
                    {
                        headerName: 'Business line',
                        field: 'business_line'
                    },
                    {
                        headerName: "Currency",
                        field: "currency_code"
                    },
                    {
                        headerName: "Placing Broker",
                        field: "mst_placing_broker_name"
                    },
                    {
                        headerName: "MST Created",
                        field: "manual_submission_created_at",
                        filter: "agDateColumnFilter",
                        valueFormatter: params => this.$moment(params.value).format('DD/MM/YYYY'),
                        useValueFormatterForExport: false,
                        filterParams: {
                            comparator: (filterLocalDateAtMidnight, cellValue) => {
                                return this.compareDates(filterLocalDateAtMidnight, cellValue);
                            },
                            browserDatePicker: true
                        }
                    },
                    {
                        headerName: "MST Last Edited",
                        field: "manual_submission_updated_at",
                        filter: "agDateColumnFilter",
                        valueFormatter: params => this.$moment(params.value).format('DD/MM/YYYY'),
                        useValueFormatterForExport: false,
                        filterParams: {
                            comparator: (filterLocalDateAtMidnight, cellValue) => {
                                return this.compareDates(filterLocalDateAtMidnight, cellValue);
                            },
                            browserDatePicker: true
                        }
                    },
                    {
                        headerName: "Date Enquiry Received",
                        field: "manual_submission_date_enquiry_received",
                        filter: "agDateColumnFilter",
                        valueFormatter: params => this.$moment(params.value).format('DD/MM/YYYY'),
                        useValueFormatterForExport: false,
                        filterParams: {
                            comparator: (filterLocalDateAtMidnight, cellValue) => {
                                return this.compareDates(filterLocalDateAtMidnight, cellValue);
                            },
                            browserDatePicker: true
                        }
                    },
                    {
                        headerName: "Anticipated Bind Date",
                        field: "manual_submission_anticipated_bind_date",
                        filter: "agDateColumnFilter",
                        valueFormatter: params => this.$moment(params.value).format('DD/MM/YYYY'),
                        useValueFormatterForExport: false,
                        filterParams: {
                            comparator: (filterLocalDateAtMidnight, cellValue) => {
                                return this.compareDates(filterLocalDateAtMidnight, cellValue);
                            },
                            browserDatePicker: true
                        }
                    },
                    {
                        headerName: "Facility UMR",
                        field: "facility_umr"
                    },
                    {
                        headerName: "Indicated Line Size",
                        field: "mst_indicated_line_size"
                    },
                    {
                        headerName: "Indicated Line Size Currency",
                        field: "mst_indicated_line_size_currency_code"
                    },
                    {
                        headerName: "UW Pricing Type",
                        field: "mst_pricing_type"
                    },
                    {
                        headerName: "UW Rate Offered",
                        field: "mst_price",
                        filter: "agNumberColumnFilter",
                        valueFormatter: this.currencyFormatter,
                        useValueFormatterForExport: false,
                        keyCreator: params => {
                            return params.value === null || typeof params.value === 'undefined' ? '' : this.numberFormatter(params.value);
                        },
                    },
                    {
                        headerName: "UW % of Margin Offered",
                        field: "mst_margin_percentage",
                        valueFormatter: this.percentageFormatter,
                        useValueFormatterForExport: false,
                        filterParams: {
                            valueFormatter: this.percentageFormatter
                        },
                        keyCreator: params => {
                            return params.value === null || typeof params.value === 'undefined' ? '' : this.numberFormatter(params.value);
                        }
                    },
                    {
                        headerName: "UW Fee",
                        field: "mst_fee",
                        filter: "agNumberColumnFilter",
                        valueFormatter: this.currencyFormatter,
                        useValueFormatterForExport: false,
                        keyCreator: params => {
                            return params.value === null || typeof params.value === 'undefined' ? '' : this.numberFormatter(params.value);
                        },
                    }
                    ]);
                    this.gridApi.setGridOption('rowData', this.manualSubmissions);
                    this.tableLayouts = [];
                }
                if (this.tableView === 'Offers') {
                    this.gridApi.setGridOption('columnDefs', this.offerColumnDefs);
                    this.gridApi.setGridOption('rowData', this.offers);
                    this.tableLayouts = this.offerTableLayouts;
                    this.disableShowChartBtn = true;
                }
                if (this.tableView === 'Declarations') {
                    this.disableShowChartBtn = false;

                    this.gridApi.setGridOption('columnDefs', this.declarationColumnDefinition);
                    this.gridApi.setGridOption('rowData', this.lines);

                    this.tableLayouts = this.declarationTableLayouts;
                }

                this.autoSizeAll(false);

                this.closeChart();
            },
            getOfferType(status) {
                switch (status) {
                    case 'rate':
                        return 'Rate';
                    case 'flat_fee':
                        return 'Flat fee';
                    case 'percentage_of_net_margin':
                        return 'Percentage of net margin';
                    case 'percentage_of_gross_margin':
                        return 'Percentage of gross margin';
                }
            },
            getContextMenuItems(params) {
                return [
                    {
                        name: "Go to summary",
                        action: () => {
                            this.goToSummary(params.node.data);
                        },
                    },
                    'separator',
                    'copy',
                    'export',
                    'chartRange',
                ];
            },
            goToSummary(data) {
                let companyType;

                if (this.isInsurer) {
                    companyType = 'insurer';
                }
                if (this.isBroker) {
                    companyType = 'agent';
                }

                if (data.risk_id) {
                    this.$router.push(`/${companyType}/risk/${data.risk_id}`);
                }
                if (data.declaration) {
                    this.$router.push(`/${companyType}/risk/${data.declaration.risk_id}`);
                }
                if (data.submission) {
                    this.$router.push(`/${companyType}/risk/${data.submission.risk_id}`);
                }
            },
            resetTableLayout() {
                this.layout = {
                    name: ''
                };
                this.loadTableLayout(this.layout);
            },
            onShowChart() {
                if (this.createdChartRef) {
                    this.createdChartRef.destroyChart();
                }

                const params = {
                    cellRange: {
                        rowStartIndex: this.rowStartIndex,
                        rowEndIndex: this.rowEndIndex,
                        columns: ['line_size_signed_amount'],
                    },
                    chartType: 'groupedColumn',
                    chartThemeName: 'ag-vivid',
                    chartThemeOverrides: {
                        common: {
                            title: {
                                enabled: true,
                                text: 'Contract value per policy',
                            },
                        },
                    },
                };
                this.createdChartRef = this.gridApi.createRangeChart(params);
            },
            closeChart() {
                if (this.createdChartRef) {
                    this.createdChartRef.destroyChart();
                    this.createdChartRef = null;
                }
            },
            riskCodes(params) {
                if (params.data.uw_risk_code === null || params.data.uw_risk_code === 'undefined' || params.data.uw_risk_code === '') {
                    return params.data.risk_code_names;
                }
                return params.data.uw_risk_code;
            }
        },
    }
</script>

<style lang="scss">

@use "ag-grid-community/styles" as ag;
@include ag.grid-styles((
    theme: balham-dark,
));

.ag-theme-balham-dark {
    background: transparent;

    .ag-column-drop-horizontal.ag-column-drop {
        background: transparent;
        border: 0;
    }

    .ag-root {
        border: 0 !important;
    }

    .ag-header {
        background: transparent;
        border: 0;
        text-transform: uppercase;
        font-size: 0.75rem;
        font-weight: 600;
        font-family: $font-body;
        color: $color-white;
    }

    .ag-header-cell, .ag-header-group-cell {
        border: 0 !important;
    }

    .ag-row {
        border: 0;
    }

    .ag-row-odd {
        background: transparent;
    }

    .ag-row-even {
        background: rgba(255, 255, 255, 0.05);
    }

    .ag-ltr .ag-has-focus .ag-cell-focus.ag-cell-range-single-cell {
        border-color: $color-secondary;
    }

    .ag-header-viewport, .ag-center-cols-viewport, .ag-body-horizontal-scroll-viewport {
        border: 0 !important;
    }

    .ag-input-wrapper {
        input:not([type]),
        input[type=text],
        input[type=number],
        input[type=tel],
        input[type=date],
        input[type=datetime-local] {
            height: 32px;
            background: rgba(255, 255, 255, 0.15);
            border-radius: 8px;
            border-color: transparent;
            padding: 0 12px;

            &:disabled {
                background: transparent;
                border-color: rgba(255, 255, 255, 0.5);
            }
        }
    }

    .ag-menu {
        background-color: $color-primary;

        .ag-menu-list {
            padding: 8px 0;
        }

        .ag-menu-option {
            .ag-menu-option-icon {
                padding-left: 12px;
            }

            .ag-menu-option-popup-pointer {
                padding-right: 12px;
            }
        }

        .ag-menu-option-active {
            background-color: $color-secondary;
            color: $color-primary;

            .ag-icon {
                color: $color-primary;
            }
        }

        .ag-tab-header {
            display: none;
        }

        .ag-tab-body {
            background-color: $color-primary;

            .ag-filter-header-container {
                padding: 0 12px;
                border-bottom: 1px solid rgba(255, 255, 255, 0.05);

                .ag-input-wrapper {
                    padding: 12px 0;
                }
            }

            .ag-set-filter-list {
                padding: 0 12px 12px;
                height: 180px;
            }

            .ag-icon-checkbox-checked {
                color: $color-secondary;
            }
        }

        .ag-tab {
            @media screen and (min-width: 1920px) {
                width: 150px;
            }
        }
    }

    .ag-column-drop-horizontal,
    .ag-status-bar,
    .ag-body-horizontal-scroll {
        background-color: transparent;
        border: 0;
    }

    .ag-header-viewport,
    .ag-center-cols-viewport,
    .ag-body-horizontal-scroll-viewport {
        border-left: 1px solid #C1CCD6;
    }

    .ag-pinned-left-cols-container {
        border-top: 1px solid #C1CCD6;
    }

    .ag-center-cols-viewport {
        border-top: 1px solid #D9D9D9;
    }

    .ag-side-bar {
        background: transparent;
        border: 0;

        .ag-side-buttons {
            background: rgba(255, 255, 255, 0.05);
            border: 1px solid rgba(255, 255, 255, 0.1);
            width: 40px;

            .ag-selected {
                button {
                    background-color: rgba(255, 255, 255, 0.05);
                    border-color: transparent;
                }
            }
        }
    }

    .ag-filter-toolpanel-body {
        background-color: $color-primary;
    }

    .ag-tool-panel-wrapper {
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 8px 0 0 8px;

        .ag-filter-panel {
            .ag-filter-toolpanel-header {
                & > div.ag-input-wrapper {
                    padding: 0 12px;
                }
            }

            .ag-group-component-container {
                .ag-group-item {
                    margin: 0;

                    .ag-filter-toolpanel-body:not(:empty) {
                        margin: 0;
                    }
                }
            }

            .ag-group-component {
                background-color: rgba(255, 255, 255, 0.05);

                .ag-group-component-title-bar {
                    background-color: rgba(255, 255, 255, 0.05);
                    border-color: rgba(255, 255, 255, 0.1) !important;
                }
            }
        }

        .ag-column-select-panel .ag-primary-cols-header-panel,
        .ag-column-select-panel .ag-primary-cols-list-panel,
        .ag-pivot-mode-panel,
        .ag-column-drop {
            padding-left: 12px;
            padding-right: 12px;
        }
    }

    .ag-filter {
        .ag-filter-header-container, .ag-set-filter-list {
            padding: 12px;
        }

        .ag-filter-header-container {
            border-color: rgba(255, 255, 255, 0.1);

            .ag-input-wrapper {
                margin-bottom: 12px;
            }
        }
    }

    .ag-icon-checkbox-checked {
        color: $color-secondary;
    }

    .ag-paging-panel {
        border: 0;
    }

    &.ag-popup > div:not(.ag-tooltip-custom) {
        border: 1px solid $color-pistachio;
        border-radius: 8px;
    }
}

.ag-chart-tooltip-content {
    border: 0;
}
</style>

<style lang="scss" scoped>

    .sub-heading {
        font-size: 20px;
        padding: 20px;
    }

    .grid-totals{
        font-size: rem(14px);
    }

    .filter-panel {

        font-size: rem(14px) !important;

        .flex {
            padding-top: 0 !important;
            padding-bottom: 0 !important;
            height: 100%;
        }

        .label-view {
            max-width: 60px;
        }

        &.input-no-margin :deep() {
            .x-input__control .x-input__slot {
                margin: 0;
            }
        }
    }
</style>
